/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { TaskDataInt } from '../../../../../../../models/task.model';

@Component({
  selector: 'app-int-item',
  templateUrl: './int-item.component.html',
  styleUrls: ['./int-item.component.scss'],
  standalone: false
})
export class IntItemComponent implements OnInit {
  @Input() intItem: TaskDataInt = new TaskDataInt(0);

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
